'use client'

import { cn } from '@lib/cn'

const DotsSpinner = ({ className }: { className?: string }) => (
  <span role="status" aria-label="Loading" className={cn('dots-spinner inline-flex items-center gap-1', className)}>
    {[0, 1, 2].map((index) => (
      <span key={index} className="size-[5px] rounded-full bg-current" style={{ animationDelay: `${index * 150}ms` }} />
    ))}
    <style jsx>{`
      @keyframes dots-fade {
        0%,
        80%,
        100% {
          opacity: 0.25;
        }
        40% {
          opacity: 1;
        }
      }

      .dots-spinner > span {
        animation: dots-fade 1s cubic-bezier(0.645, 0.045, 0.355, 1) infinite both;
      }

      @media (prefers-reduced-motion: reduce) {
        .dots-spinner > span {
          animation: none;
          opacity: 0.6;
        }
      }
    `}</style>
  </span>
)

export default DotsSpinner
